import styled from 'styled-components';

export const DropDownButton = styled.div`
  font-size: 15px;
  font-weight: bold;
  text-decoration: none;
  color: black;
  padding: 10px 20px;
  transition: ease-in-out 0.2s;

  &:hover {
    background-color: #c1dbd9;
    color: black;
    border-radius: 5px;
    cursor: pointer;
  }
`;
